import template from './template';

const HeaderNotification = () => ({
    template: template,
    restrict: 'E',
    replace: true,
});

export default HeaderNotification;